import TagManager from 'react-gtm-module'

let gtmInitialised = false

export const generateUserHash = async (email) => {
	const encoder = new TextEncoder()
	const data = encoder.encode(email)
	const hashBuffer = await crypto.subtle.digest('SHA-256', data)
	const hashArray = Array.from(new Uint8Array(hashBuffer))
	return hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('')
}

export const initialiseGTM = () => {
	const GTM_ID = import.meta.env.VITE_GTM_ID

	if (import.meta.env.MODE !== 'production') {
		console.warn('GTM not initialised: Not in production mode')
		return
	}

	const loadGTM = () => {
		if (window.Cookiebot && window.Cookiebot.consent?.statistics) {
			if (GTM_ID) {
				TagManager.initialize({ gtmId: GTM_ID })
				console.log('GTM Initialised')
				gtmInitialised = true
			} else {
				console.warn('GTM ID not present')
			}
		} else {
			console.warn('GTM not initialised - No analytics consent')
			if (gtmInitialised) {
				// Remove GTM scripts
				const gtmScripts = document.querySelectorAll(
					'script[src*="googletagmanager"]'
				)
				gtmScripts.forEach((s) => s.remove())

				// Remove GTM iframe
				const gtmIframes = document.querySelectorAll(
					'iframe[src*="googletagmanager"]'
				)
				gtmIframes.forEach((i) => i.remove())
				window.location.reload()
			}
		}
	}

	const waitForCookiebot = setInterval(() => {
		if (window.Cookiebot) {
			clearInterval(waitForCookiebot)
			loadGTM()

			window.addEventListener('CookiebotOnConsentReady', () => {
				console.log('Cookiebot consent ready')
				loadGTM()
			})

			window.addEventListener('CookiebotOnConsentChanged', () => {
				console.log('Cookiebot consent changed')
				loadGTM()
			})
		}
	}, 200)
}

export const pushToDataLayer = (eventName, eventData = {}) => {
	if (window && window.dataLayer) {
		window.dataLayer.push({
			event: eventName,
			...eventData
		})
	} else {
		console.warn('GTM Data Layer not found')
	}
}

export const pushPageView = (userHash, organisation, pagePath) => {
	pushToDataLayer('page_view', { userHash, organisation, pagePath })
}

export const pushLoginEvent = (organisation, userHash) => {
	pushToDataLayer('login_success', {
		organisation,
		userHash
	})
}

export const pushPWAInstallPromptEvent = (
	organisation = 'not authenticated',
	userHash = 'not authenticated'
) => {
	pushToDataLayer('pwa_install_prompt', {
		userHash,
		organisation,
		triggered: true,
		timestamp: new Date().toISOString()
	})
}

export const pushPWAInstalledEvent = (
	organisation = 'not authenticated',
	userHash = 'not authenticated'
) => {
	pushToDataLayer('pwa_installed', {
		userHash,
		organisation,
		status: 'success',
		timestamp: new Date().toISOString()
	})
}

export const pushExternalLinkClickedEvent = (
	organisation,
	userHash,
	href,
	isSocialMedia
) => {
	pushToDataLayer('external_link_click', {
		userHash,
		organisation,
		href,
		isSocialMedia
	})
}

export const pushSearchTermEvent = (
	searchTerm,
	organisation,
	userHash,
	recentSearchClicked = false
) => {
	if (!searchTerm) {
		console.warn('No search term provided for GTM event')
		return
	}

	pushToDataLayer('search_term', {
		userHash,
		organisation,
		searchTerm,
		recentSearchClicked,
		timestamp: new Date().toISOString()
	})
}
